import uniqueId from 'lodash/uniqueId';
import { di } from 'react-magnetic-di';
import { getSupportedFieldConfiguration } from '../../../view-configuration';
import { calculateNextFormValue } from '../../utils/calculate-next-form-value';
/**
 * Responsible for notifying UIM store about last processed change.
 */
export var processChange = function processChange(_ref) {
  var fieldId = _ref.fieldId,
    fieldValue = _ref.fieldValue,
    eventType = _ref.eventType;
  return function (_ref2, _ref3) {
    var _internalFormMetadata, _getSupportedFieldCon;
    var setState = _ref2.setState,
      getState = _ref2.getState;
    var viewType = _ref3.viewType;
    var _getState = getState(),
      internalFormMetadata = _getState.internalFormMetadata,
      formData = _getState.formData;
    var fieldType = (_internalFormMetadata = internalFormMetadata[fieldId]) === null || _internalFormMetadata === void 0 ? void 0 : _internalFormMetadata.fieldType;
    if (!fieldType) {
      return;
    }
    var emitChangeOn = (_getSupportedFieldCon = getSupportedFieldConfiguration(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.emitChangeOn;
    if (emitChangeOn !== eventType) {
      return;
    }
    var nextFormData = calculateNextFormValue({
      internalFormMetadata: internalFormMetadata,
      formData: formData,
      fieldType: fieldType,
      fieldId: fieldId,
      fieldValue: fieldValue,
      viewType: viewType
    });
    if (nextFormData === null) {
      return;
    }

    /**
     * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
     * Otherwise, UIM app may not be notified about every single change.
     */
    setTimeout(function () {
      var changeId = uniqueId();
      setState({
        lastProcessedChange: {
          fieldId: fieldId,
          changeId: changeId
        },
        formData: nextFormData
      });
    }, 0);
  };
};